import Vue from "vue";
import Router from "../router";

export default class ProductOptions extends Vue {

  static getProductOptions = {
    itemPerPage: [12, 24, 36],
    sortAttributes: [
      { id: "price.asc", value: "Price ascending" },
      { id: "price.desc", value: "Price descending" },
      { id: "name.asc", value: "Name A - Z" },
      { id: "name.desc", value: "Name Z - A" },
      { id: "reference.asc", value: "Reference" }],
    allowEmptyStock: false,
    minimalQuantity: 5,
  };

  static changeItemsPerPage(itemsPerPage: string): void {
    const { query } = Router.history.current;
    delete query.page;
    Router.push({ query: { ...query, itemsPerPage } }).catch(() => {
      return;
    });
  }

  static changeSorting(sort: string): void {
    const { query } = Router.history.current;
    Router.push({ query: { ...query, sort } }).catch(() => {
      return;
    });
  }

}
